export const COMBOS = [
  {
    id: "combo-starter-visibility",
    title: "Starter Visibility Combo",
    tag: "Entry",
    description: "For brands that want to support the team and gain digital visibility.",
    includes: ["Website logo", "Social media mention", "Sponsor grid presence", "Portfolio logo"],
  },
  {
    id: "combo-digital-impact",
    title: "Digital Impact Combo",
    tag: "Content",
    description: "For brands focused on content, social media, and storytelling.",
    includes: ["Instagram posts", "Instagram stories", "LinkedIn sponsor highlight", "Behind-the-scenes content", "Sponsor video feature"],
  },
  {
    id: "combo-world-finals",
    title: "World Finals Combo",
    tag: "Global",
    description: "For companies that want to be part of Brazil's journey to Singapore.",
    includes: ["Premium logo exposure", "World Finals campaign content", "Presentation presence", "Uniform visibility", "Website feature", "International exposure"],
  },
  {
    id: "combo-innovation-partner",
    title: "Innovation Partner Combo",
    tag: "STEM",
    description: "For technology, engineering, education, and innovation-focused brands.",
    includes: ["Engineering content", "CAD/CFD storytelling", "Technical sponsor feature", "Social media content", "Website highlight", "Brand association with STEM education"],
  },
  {
    id: "combo-premium-partner",
    title: "Premium Partner Combo",
    tag: "Most Popular",
    popular: true,
    description: "For brands looking for maximum visibility and long-term association with Alight Racing.",
    includes: ["Uniform logo", "Pit display logo", "Car render/logo placement", "Website feature", "Social media campaign", "Event visibility", "Portfolio presence", "Presentation mention", "World Finals campaign exposure"],
  },
  {
    id: "combo-custom",
    title: "Custom Package",
    tag: "Tailored",
    description: "Create a partnership built around your company's goals.",
    includes: ["Fully tailored deliverables", "Custom brand activation", "Direct collaboration with the team"],
  },
];

export const BENEFIT_CATEGORIES = [
  {
    key: "brand-visibility",
    title: "Brand Visibility Benefits",
    subtitle: "Show your logo where the world will see it.",
    items: [
      "Logo on team uniform",
      "Logo on car render",
      "Logo on pit display",
      "Logo on website",
      "Logo in official portfolios",
      "Brand mention in presentations",
    ],
  },
  {
    key: "digital-content",
    title: "Digital Content Benefits",
    subtitle: "Storytelling built around your brand.",
    items: [
      "Social media post",
      "Instagram story package",
      "LinkedIn sponsor highlight",
      "Behind-the-scenes branded content",
      "Sponsor video feature",
      "Product placement in media content",
    ],
  },
  {
    key: "event-competition",
    title: "Event & Competition Exposure",
    subtitle: "Be present where performance is made.",
    items: [
      "Event activation",
      "Brand exposure during events",
      "Pit display sponsor area",
      "World Finals campaign exposure",
      "International visibility at the World Finals",
    ],
  },
  {
    key: "world-finals",
    title: "World Finals Exposure",
    subtitle: "Represent your brand on the global stage in Singapore.",
    items: [
      "Singapore campaign feature",
      "Global press moment",
      "Portfolio international feature",
      "World Finals branded content",
    ],
  },
  {
    key: "education-sustainability",
    title: "Education & Sustainability Impact",
    subtitle: "Purpose-driven association with youth and innovation.",
    items: [
      "Educational project support",
      "Social project support",
      "Sustainability project support",
      "Community engagement campaign",
      "STEM education storytelling",
    ],
  },
  {
    key: "premium-partnership",
    title: "Premium Partnership Benefits",
    subtitle: "Long-term, high-visibility partnership.",
    items: [
      "Main sponsor highlight",
      "Long-term partner page feature",
      "Premium sponsor card on website",
      "Featured sponsor campaign",
      "Customized brand activation",
    ],
  },
];

export const BENEFITS = BENEFIT_CATEGORIES.flatMap((cat) =>
  cat.items.map((title, idx) => ({
    id: `${cat.key}-${idx}`,
    title,
    category: cat.title,
    categoryKey: cat.key,
  }))
);

export const TEAM = [
  { id: "pietro", name: "Pietro Moreira", role: "Project Manager", number: "01", bio: "Leads the strategic direction, planning, and execution of every phase of the Alight Racing project." },
  { id: "benjamin", name: "Benjamin Lueders", role: "Marketing Director", number: "07", bio: "Builds the Alight Racing brand, sponsor storytelling, and content strategy across every platform." },
  { id: "nata", name: "Natã Fermino", role: "CAD Engineer", number: "12", bio: "Designs the aerodynamic surfaces, CAD geometry, and CFD-driven refinements of the race car." },
  { id: "lucas", name: "Lucas Guerzoni", role: "Manufacturing Engineer", number: "23", bio: "Transforms digital designs into precision-machined parts using CAM, CNC, and 3D-printing." },
];

export const STEM_PILLARS = [
  { title: "Engineering", desc: "Aerodynamics, CAD, CFD, testing, and technical design.", icon: "Wrench" },
  { title: "Enterprise", desc: "Sponsorship, finance, value delivery, and business strategy.", icon: "Briefcase" },
  { title: "Project Management", desc: "Planning, deadlines, team coordination, and execution.", icon: "Kanban" },
  { title: "Marketing", desc: "Brand identity, content, storytelling, and visibility.", icon: "Megaphone" },
  { title: "Sustainability", desc: "Environmental responsibility and conscious project decisions.", icon: "Leaf" },
  { title: "Presentation", desc: "Professional communication and verbal pitch performance.", icon: "Presentation" },
  { title: "Pit Display", desc: "Immersive team identity and sponsor visibility.", icon: "Flag" },
  { title: "Racing Performance", desc: "Speed, precision, manufacturing quality, and testing.", icon: "Gauge" },
];

export const VALUES = ["Precision", "Innovation", "Ambition", "Responsibility", "Teamwork", "Professionalism", "Education", "Global Impact"];
